import { memo } from 'react';
import { UseControllerProps, useController, UseFormSetValue } from 'react-hook-form';
import { InputPhone } from 'src/components/common';
import { InputPhoneProps } from 'src/components/common/InputPhone';

const FormInputPhone = ({ control, setValue, ...props }: Props) => {
  const { field, fieldState } = useController({ name: props.name, control: control });

  return (
    <InputPhone
      label={props.label}
      {...props}
      {...field}
      onChange={setValue}
      errorMessage={fieldState.error?.message}
    />
  );
};

type Props<T = any> = UseControllerProps<T> &
  InputPhoneProps & {
    setValue: UseFormSetValue<T>;
  };

export default memo(FormInputPhone);
